// extracted by mini-css-extract-plugin
export default {"container":"markdown_container__zkxE-"};